import { render } from "./SmIconSidebarModalEditComponent.vue?vue&type=template&id=c7a3c8da"
import script from "./SmIconSidebarModalEditComponent.vue?vue&type=script&lang=js"
export * from "./SmIconSidebarModalEditComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/components/buttons/SmIconSidebarModalEditComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c7a3c8da"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c7a3c8da', __exports__)) {
    api.reload('c7a3c8da', __exports__)
  }
  
  module.hot.accept("./SmIconSidebarModalEditComponent.vue?vue&type=template&id=c7a3c8da", () => {
    api.rerender('c7a3c8da', render)
  })

}


export default __exports__